import React, { useState } from "react";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import { Button, Layout, message, Table, Spin } from "antd";
import axios from 'axios';
import './FinalMasterAudit.css'
import Cookies from "js-cookie";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';

const { Header, Content } = Layout;

const FinalMasterAudit = () => {
    const jwtToken = Cookies.get("jwt_token");
    const userLogin = Cookies.get("UserLogin");

    const [SNfile, setSNFile] = useState(null)
    const [Activefile, setActiveFile] = useState(null)
    const [SNdata, getSNData] = useState([])
    const [ActivelistData, getActiveData] = useState([])
    const [ComparisionList, getComparisionData] = useState([])
    const [tableLoader, setTableLoader] = useState(false)
    const [fileLoader, setFileLoader] = useState(false)
    const pageSize = 10;

    const handleSNFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile !== undefined) {
            if (selectedFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                setSNFile(selectedFile);
            }
            else {
                message.error('Please upload a valid Excel file (XLSX format).');
                setSNFile(null)
            }
        }
        else {
            setSNFile(null)
            setActiveFile(null)
            getSNData([])
        }
    };
    const handleActiveFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile !== undefined) {
            if (selectedFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                setActiveFile(selectedFile);
            }
            else {
                message.error('Please upload a valid Excel file (XLSX format).');
                setActiveFile(null)
            }
        }
        else {
            setSNFile(null)
            setActiveFile(null)
            getSNData([])
        }
    };



    const handleFilesUpload = async (props) => {
        if (!SNfile || !Activefile) {
            message.error("Please upload both files")
        }
        else {
            setTableLoader(true)
            const formData = new FormData();
            formData.append('firstFile', SNfile);
            formData.append('secondfile', Activefile);

            axios.post(`${process.env.REACT_APP_BASE_URL}FinalMasterAudit/SNupload`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${jwtToken}`,
                }
            })
                .then((response) => {
                    if (response.data.statusCode === 200) {
                        const resdata = response.data.payload
                        const res = JSON.parse(resdata)
                        getSNData(res.SNData);
                        getActiveData(res.ActiveListData)
                        getComparisionData(res.ComparisonResults)
                        message.success('Uploaded successfully!');
                        setSNFile(null)
                        setActiveFile(null)
                        setTableLoader(false)
                    }
                    else if (response.data.statusCode === 500) {
                        message.warning(response.data.message)
                        getSNData([])
                        setTableLoader(false)
                    }
                    else {
                        setTableLoader(false)
                        getSNData([])
                        setSNFile(null)
                        setActiveFile(null)
                    }
                })
                .catch((error) => {
                    message.error('Error while uploading file');
                    setTableLoader(false)
                })
        }
    };
    const handleExcelList = () => {
        let snList = SNdata;
        let loopedList = [];
        loopedList.length = 0;
        let len = snList.length;
        let i;
        loopedList.push(['File Number', 'Clientname in SN', 'Clientname in Activelist', 'Payrate', 'Pay Frequency Code',
            'Work State', 'HomeState Province', 'Temp WorkState Province', 'Exempt Status', 'DOB', 'Remarks'
        ])
        for (i = 0; i < len; i++) {
            loopedList.push([
                snList[i].PayrollFileNumber,
                snList[i].Client,
                snList[i].Activelist_Client,
                snList[i].PayRate,
                snList[i].PaymentFrequency,
                snList[i].WorkState,
                snList[i].HomeStateProvince,
                snList[i].TempWorkStateProvince,
                snList[i].ExemptStatus,
                snList[i].DOB,
                snList[i].Remarks,
            ]);
        }
        handleOnExport(loopedList);
    };

    const handleOnExport = async (props) => {
        setFileLoader(true)
        try {
            const payData = props;
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            for (let i = 0; i < payData.length; i++) {
                worksheet.addRow(payData[i]);
                if (!payData[i][10] || payData[i][10].trim() === "") {
                    worksheet.getRow(i + 1).fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "00FF00" },
                    };
                } else if (payData[i][10].toLowerCase().includes("mismatch")) {
                    worksheet.getRow(i + 1).fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FF0000" },
                    };
                }
            }
            message.success("Downloaded successfully !!")
            setFileLoader(false)
            return workbook.xlsx.writeBuffer()
                .then(buffer => {
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    FileSaver.saveAs(blob, 'FinalMasterAudit.xlsx');
                });


        }
        catch (err) {
            message.error("Cannot able download, please try again")
            setFileLoader(false)
        }
    };


    const columns = [
        {
            title: 'File Number',
            dataIndex: 'PayrollFileNumber',
            key: 'File Number',
            width: 100,
            height: 50,
            fixed: "left",
        },
        {
            title: 'Client',
            dataIndex: 'Client',
            key: 'Client',
            width: 100,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.Client);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        // {
        //     title: 'Client in Activelist',
        //     dataIndex: 'activelist_Client',
        //     key: 'Client',

        // },
        {
            title: 'Pay Rate',
            dataIndex: 'PayRate',
            key: 'Pay Rate',
            width: 80,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.PayRate);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'Pay Frequency Code',
            dataIndex: 'PaymentFrequency',
            key: 'Pay Frequency Code',
            width: 150,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.PaymentFrequency);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'Work State',
            dataIndex: 'WorkState',
            key: 'Work State',
            width: 100,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.WorkState);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'HomeState Province',
            dataIndex: 'HomeStateProvince',
            key: 'HomeState Province',
            width: 200,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.HomeStateProvince);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'TempWorkState Province',
            dataIndex: 'TempWorkStateProvince',
            key: 'TempWorkState Province',
            width: 200,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.TempWorkStateProvince);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'Exempt Status',
            dataIndex: 'ExemptStatus',
            key: 'Exempt Status',
            width: 120,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.ExemptStatus);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'DOB',
            dataIndex: 'DOB',
            key: 'DOB',
            width: 50,
            height: 50,
            render: (text, record) => {
                const isHighlighted = ComparisionList.some(item => item.PayrollFileNumber === record.PayrollFileNumber && item.DOB);
                return (
                    <span style={{ color: isHighlighted ? 'green' : 'red' }}>
                        {text}
                    </span>
                );
            },
        },
        {
            title: 'Remarks',
            dataIndex: 'Remarks',
            key: 'Remarks',
            width: 70,
            height: 50,
        },
    ];


    return (
        <>
            <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
                <SideNavBar />
                <Layout className="whole-div">
                    <Header className="timecards-header">
                        <Navbar />
                    </Header>
                    <Content >
                        <h1 className="finalmasteraudit-title">Final Master Audit</h1>
                        <div className="finalaudit-input-div">
                            <div className="firstfile-div">
                                <input type="file" accept=".xlsx" onChange={handleSNFileChange} />
                                <label
                                    style={{ marginTop: "10px", fontSize: "11.3px", color: "#096DD9" }}
                                >
                                    *Upload SN file here.
                                </label>
                            </div>
                            <div className="firstfile-div">
                                <input type="file" accept=".xlsx" onChange={handleActiveFileChange} />
                                <label
                                    style={{ marginTop: "10px", fontSize: "11.3px", color: "#096DD9" }}
                                >
                                    *Upload Activelist file here.
                                </label>

                            </div>
                            
                            <Button className="upload-file" style={{ marginLeft: "3%" }} onClick={handleFilesUpload}> Upload </Button>
                            <Button className="upload-file" loading={fileLoader} style={{ marginLeft: "20%" }} onClick={handleExcelList}>Download</Button>
                        </div>
                        <div className="finalaudit-table-div">
                            {
                                tableLoader ? <Spin tip="Loading...">
                                    <Table className="masteraudit-table"
                                        bordered
                                        scroll={{ x: "max-content", y: 350 }}
                                        columns={columns}
                                        //pagination={{ pageSize, position: ['bottomRight'] }}
                                        dataSource={SNdata.map(item => ({ ...item, key: item.Id }))}
                                    />
                                </Spin> : SNdata ?
                                    <Table className="masteraudit-table"
                                        columns={columns}
                                        bordered
                                        //pagination={{ pageSize, position: ['bottomRight'] }}
                                        dataSource={SNdata.map(item => ({ ...item, key: item.Id }))}
                                        scroll={{ x: "max-content", y: 350 }}
                                    />
                                    : null
                            }
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </>
    )
}
export default FinalMasterAudit;